import AssetStatus from './AssetStatus'
import ChangeAssetStatusModal from './ChangeAssetStatusModal'

export default AssetStatus
export { ChangeAssetStatusModal }
